export default __webpack_public_path__ + "images/c7ea36274e812d76edb958a99e7626d4.png";